// general
//import Antispam from '../../components/Antispam';

import CookieBubble from '../../components/CookieBubble'
import CheckboxCheck from './CheckboxCheck'
// project
import Scroll from './Scroll'

const Components = {
    //Antispam: Antispam,
    Scroll,
    CookieBubble,
    CheckboxCheck
};

export default Components;



// WEBPACK FOOTER //
// ./components/index.js